import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files from components
import headerTranslations from "../components/Header/translations.json";
import footerTranslations from "../components/Footer/translations.json";
import profileTranslations from "../components/Profile/translations.json";
import planComponentTranslations from "../components/Plan/translations.json";
import aboutComponentTranslations from "../components/About/translations.json";
import stepTranslationsWhiteLabel from "../components/Join/whiteLabel/Step/translations.json";
import stepTranslationsRejeem from "../components/Join/rejeem/Step/translations.json";
import stepperTranslationsWhiteLabel from "../components/Join/whiteLabel/Stepper/translations.json";
import stepperTranslationsRejeem from "../components/Join/rejeem/Stepper/translations.json";
import progressDefaultTranslations from "../components/ProgressDefault/translations.json";
import dialogTranslations from "../components/Dialog/translations.json";
import planDurationTranslations from "../components/PlanDuration/translations.json";
import planSelectionTranslations from "../components/PlanSelection/translations.json";
import planPauseTranslations from "../components/PlanPause/translations.json";
import mealTranslations from "../components/Meal/translations.json";
import addressEditTranslations from "../components/AddressEdit/translations.json";
import calendarTranslations from "../components/Calendar/translations.json";
import contactTranslations from "../components/Contact/translations.json";
import loginTranslations from "../components/Login/translations.json";
import deliveryAddressTranslations from "../components/DeliveryAddress/translations.json";
import mealCustomizeTranslations from "../components/MealCustomize/translations.json";
import mobileFooterTranslations from "../components/MobileFooter/translations.json";
import mobileHeaderTranslations from "../components/MobileHeader/translations.json";
import subscriptionBannerTranslations from "../components/SubscriptionBanner/translations.json";
import tutorialTranslations from "../components/Tutorial/translations.json";
import addressSelectionTranslations from "../components/AddressSelection/translations.json";
import addressSelectionPageTranslations from "../pages/AddressSelection/translations.json";
import approvalPendingModalTranslations from "../components/ApprovalPendingModal/translations.json";
import contactPartnerTranslations from "../components/ContactPartner/translations.json";
import deliveryStatusBarTranslations from "../components/DeliveryStatusBar/translations.json";
import mapsTranslations from "../components/Maps/translations.json";
import mealDetailTranslations from "../components/MealDetail/translations.json";
import mealSwapTranslations from "../components/MealSwap/translations.json";
import planCancelTranslations from "../components/PlanCancel/translations.json";
import quickSaleTranslations from "../components/QuickSale/translations.json";
import renewSubscriptionTranslations from "../components/RenewSubscription/translations.json";
import todaysMenuTranslations from "../components/TodaysMenu/translations.json";
import mealCardTranslations from "../components/MealCard/translations.json";
import walletBalanceTranslations from "../components/WalletBalance/translations.json";
import walletHistoryTranslations from "../pages/WalletHistory/translations.json";

// Import Common components translations
import commonTranslations from "../components/Common/translations.json";

// Import translation files from pages
import aboutTranslations from "../pages/About/translations.json";
import mealPlanTranslations from "../pages/MealPlan/translations.json";
import appRedirectTranslations from "../pages/AppRedirect/translations.json";
import deliveryOptionsTranslations from "../pages/DeliveryOptions/translations.json";
import dietitianAppointmentTranslations from "../pages/DietitianAppointment/translations.json";
import homepageTranslations from "../pages/Homepage/translations.json";
import invitationConfirmTranslations from "../pages/InvitationConfirm/translations.json";
import joinTranslations from "../pages/Join/translations.json";
import landingTranslations from "../pages/Landing/translations.json";
import mealSelectionTranslations from "../pages/MealSelection/translations.json";
import mobileIndexTranslations from "../pages/MobileIndex/translations.json";
import notFoundTranslations from "../pages/NotFound/translations.json";
import paymentTranslations from "../pages/Payment/translations.json";
import planTranslations from "../pages/Plan/translations.json";
import partnerTranslations from "../pages/Partner/translations.json";
import partnersTranslations from "../pages/Partners/translations.json";
import plansTranslations from "../pages/Plans/translations.json";
import privacyTranslations from "../pages/Privacy/translations.json";
import supportTranslations from "../pages/Support/translations.json";
import termsTranslations from "../pages/Terms/translations.json";
import textAnimationDemoTranslations from "../pages/TextAnimationDemo/translations.json";
import validationTranslations from "../components/Validation/translations.json";
import onboardingTranslations from "../pages/Onboarding/translations.json";
import daySelectionTranslations from "../pages/DaySelection/translations.json";
import summaryTranslations from "../pages/Summary/translations.json";
import dietCenterTermsTranslations from "../pages/TermsAndConditions/translations.json";
import indexTranslations from "../pages/Index/translations.json";
import dietPreferenceTranslations from "../pages/DietPreference/translations.json";
import loadingTransitionTranslations from "../components/LoadingTransition/translations.json";
import planPreferencesTranslations from "../pages/PlanPreferences/translations.json";
import allPlansTranslations from "../pages/AllPlans/translations.json";
import featuredPlansTranslations from "../pages/FeaturedPlans/translations.json";
import categorySelectionTranslations from "../components/CategorySelectionPanel/translations.json";

// Import utility translations
import hooksTranslations from "../utils/translations.json";

// Combine all translations into resources
const resources = {
  en: {
    translation: {
      common: commonTranslations.en,
      plan: planComponentTranslations.en,
      partner: partnerTranslations.en,
      partners: partnersTranslations.en,
      about: aboutComponentTranslations.en,
      pages: {
        plans: plansTranslations.en,
      },
    },
    header: headerTranslations.en,
    footer: footerTranslations.en,
    profile: profileTranslations.en,
    stepWhiteLabel: stepTranslationsWhiteLabel.en,
    stepperWhiteLabel: stepperTranslationsWhiteLabel.en,
    stepRejeem: stepTranslationsRejeem.en,
    stepperRejeem: stepperTranslationsRejeem.en,
    progressDefault: progressDefaultTranslations.en,
    dialog: dialogTranslations.en,
    planDuration: planDurationTranslations.en,
    planSelection: planSelectionTranslations.en,
    planPause: planPauseTranslations.en,
    meal: mealTranslations.en,
    addressEdit: addressEditTranslations.en,
    calendar: calendarTranslations.en,
    contactComponent: contactTranslations.en,
    login: loginTranslations.en,
    deliveryAddress: deliveryAddressTranslations.en,
    mealCustomize: mealCustomizeTranslations.en,
    mobileFooter: mobileFooterTranslations.en,
    mobileHeader: mobileHeaderTranslations.en,
    subscriptionBanner: subscriptionBannerTranslations.en,
    tutorial: tutorialTranslations.en,
    aboutPage: aboutTranslations.en,
    appRedirect: appRedirectTranslations.en,
    contact: contactTranslations.en,
    deliveryOptions: deliveryOptionsTranslations.en,
    dietitianAppointment: dietitianAppointmentTranslations.en,
    homepage: homepageTranslations.en,
    invitationConfirm: invitationConfirmTranslations.en,
    join: joinTranslations.en,
    landing: landingTranslations.en,
    mealSelection: mealSelectionTranslations.en,
    mobileIndex: mobileIndexTranslations.en,
    notFound: notFoundTranslations.en,
    payment: paymentTranslations.en,
    planPage: planTranslations.en,
    planPageNS: planTranslations.en,
    privacy: privacyTranslations.en,
    support: supportTranslations.en,
    terms: termsTranslations.en,
    textAnimationDemo: textAnimationDemoTranslations.en,
    validation: validationTranslations.en,
    onboarding: onboardingTranslations.en,
    addressSelection: addressSelectionTranslations.en,
    addressSelectionPage: addressSelectionPageTranslations.en,
    approvalPendingModal: approvalPendingModalTranslations.en,
    contactPartner: contactPartnerTranslations.en,
    deliveryStatusBar: deliveryStatusBarTranslations.en,
    maps: mapsTranslations.en,
    mealDetail: mealDetailTranslations.en,
    mealSwap: mealSwapTranslations.en,
    planCancel: planCancelTranslations.en,
    quickSale: quickSaleTranslations.en,
    renewSubscription: renewSubscriptionTranslations.en,
    todaysMenu: todaysMenuTranslations.en,
    mealCard: mealCardTranslations.en,
    walletBalance: walletBalanceTranslations.en,
    walletHistory: walletHistoryTranslations.en,
    mealPlan: mealPlanTranslations.en,
    daySelection: daySelectionTranslations.en,
    summary: summaryTranslations.en,
    hooks: hooksTranslations.en,
    dietCenterTerms: dietCenterTermsTranslations.en,
    index: indexTranslations.en,
    dietPreference: dietPreferenceTranslations.en,
    loadingTransition: loadingTransitionTranslations.en,
    planPreferences: planPreferencesTranslations.en,
    allPlans: allPlansTranslations.en,
    featuredPlans: featuredPlansTranslations.en,
    categorySelection: categorySelectionTranslations.en,
  },
  ar: {
    translation: {
      common: commonTranslations.ar,
      plan: planComponentTranslations.ar,
      partner: partnerTranslations.ar,
      partners: partnersTranslations.ar,
      about: aboutComponentTranslations.ar,
      pages: {
        plans: plansTranslations.ar,
      },
    },
    header: headerTranslations.ar,
    footer: footerTranslations.ar,
    profile: profileTranslations.ar,
    stepWhiteLabel: stepTranslationsWhiteLabel.ar,
    stepperWhiteLabel: stepperTranslationsWhiteLabel.ar,
    stepRejeem: stepTranslationsRejeem.ar,
    stepperRejeem: stepperTranslationsRejeem.ar,
    progressDefault: progressDefaultTranslations.ar,
    dialog: dialogTranslations.ar,
    planDuration: planDurationTranslations.ar,
    planSelection: planSelectionTranslations.ar,
    planPause: planPauseTranslations.ar,
    meal: mealTranslations.ar,
    addressEdit: addressEditTranslations.ar,
    calendar: calendarTranslations.ar,
    contactComponent: contactTranslations.ar,
    login: loginTranslations.ar,
    deliveryAddress: deliveryAddressTranslations.ar,
    mealCustomize: mealCustomizeTranslations.ar,
    mobileFooter: mobileFooterTranslations.ar,
    mobileHeader: mobileHeaderTranslations.ar,
    subscriptionBanner: subscriptionBannerTranslations.ar,
    tutorial: tutorialTranslations.ar,
    aboutPage: aboutTranslations.ar,
    appRedirect: appRedirectTranslations.ar,
    contact: contactTranslations.ar,
    deliveryOptions: deliveryOptionsTranslations.ar,
    dietitianAppointment: dietitianAppointmentTranslations.ar,
    homepage: homepageTranslations.ar,
    invitationConfirm: invitationConfirmTranslations.ar,
    join: joinTranslations.ar,
    landing: landingTranslations.ar,
    mealSelection: mealSelectionTranslations.ar,
    mobileIndex: mobileIndexTranslations.ar,
    notFound: notFoundTranslations.ar,
    payment: paymentTranslations.ar,
    planPage: planTranslations.ar,
    planPageNS: planTranslations.ar,
    privacy: privacyTranslations.ar,
    support: supportTranslations.ar,
    terms: termsTranslations.ar,
    textAnimationDemo: textAnimationDemoTranslations.ar,
    validation: validationTranslations.ar,
    onboarding: onboardingTranslations.ar,
    addressSelection: addressSelectionTranslations.ar,
    addressSelectionPage: addressSelectionPageTranslations.ar,
    approvalPendingModal: approvalPendingModalTranslations.ar,
    contactPartner: contactPartnerTranslations.ar,
    deliveryStatusBar: deliveryStatusBarTranslations.ar,
    maps: mapsTranslations.ar,
    mealDetail: mealDetailTranslations.ar,
    mealSwap: mealSwapTranslations.ar,
    planCancel: planCancelTranslations.ar,
    quickSale: quickSaleTranslations.ar,
    renewSubscription: renewSubscriptionTranslations.ar,
    todaysMenu: todaysMenuTranslations.ar,
    mealCard: mealCardTranslations.ar,
    walletBalance: walletBalanceTranslations.ar,
    walletHistory: walletHistoryTranslations.ar,
    mealPlan: mealPlanTranslations.ar,
    daySelection: daySelectionTranslations.ar,
    summary: summaryTranslations.ar,
    hooks: hooksTranslations.ar,
    dietCenterTerms: dietCenterTermsTranslations.ar,
    index: indexTranslations.ar,
    dietPreference: dietPreferenceTranslations.ar,
    loadingTransition: loadingTransitionTranslations.ar,
    planPreferences: planPreferencesTranslations.ar,
    allPlans: allPlansTranslations.ar,
    featuredPlans: featuredPlansTranslations.ar,
    categorySelection: categorySelectionTranslations.ar,
  },
};

// Custom language detector for MENA region targeting
const customLanguageDetector = {
  name: "customDetector",
  lookup(): string | undefined {
    // Check localStorage first for user preference
    const savedLang = localStorage.getItem("i18nextLng");
    if (savedLang && (savedLang === "en" || savedLang === "ar")) {
      return savedLang;
    }

    // Check URL path for language prefix
    const pathname = window.location.pathname;
    const urlLang = pathname.split("/")[1];
    if (urlLang === "ar" || urlLang === "en") {
      return urlLang;
    }

    // Detect browser language for MENA region
    const browserLang = navigator.language || (navigator as any).userLanguage;

    // MENA region language codes that should default to Arabic
    const arabicLanguageCodes = [
      "ar",
      "ar-SA",
      "ar-AE",
      "ar-KW",
      "ar-QA",
      "ar-BH",
      "ar-OM",
      "ar-EG",
      "ar-JO",
      "ar-LB",
      "ar-IQ",
      "ar-SY",
      "ar-YE",
      "ar-MA",
      "ar-TN",
      "ar-DZ",
      "ar-LY",
      "ar-SD",
    ];

    // Check if browser language matches Arabic/MENA
    if (arabicLanguageCodes.some((code) => browserLang.startsWith(code))) {
      return "ar";
    }

    // Default to English
    return "en";
  },
  cacheUserLanguage(lng: string) {
    localStorage.setItem("i18nextLng", lng);
  },
};

// Create custom detector plugin
const languageDetectorPlugin = new LanguageDetector();
languageDetectorPlugin.addDetector(customLanguageDetector);

i18n
  .use(languageDetectorPlugin)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    defaultNS: "translation",
    ns: [
      "translation",
      "header",
      "footer",
      "profile",
      "step",
      "stepper",
      "progressDefault",
      "dialog",
      "planDuration",
      "planSelection",
      "planPause",
      "meal",
      "addressEdit",
      "calendar",
      "contactComponent",
      "login",
      "deliveryAddress",
      "mealCustomize",
      "mobileFooter",
      "mobileHeader",
      "subscriptionBanner",
      "tutorial",
      "about",
      "appRedirect",
      "contact",
      "deliveryOptions",
      "dietitianAppointment",
      "homepage",
      "invitationConfirm",
      "join",
      "landing",
      "mealSelection",
      "mobileIndex",
      "notFound",
      "payment",
      "planPage",
      "planPageNS",
      "privacy",
      "support",
      "terms",
      "textAnimationDemo",
      "validation",
      "onboarding",
      "addressSelection",
      "addressSelectionPage",
      "approvalPendingModal",
      "contactPartner",
      "deliveryStatusBar",
      "maps",
      "mealDetail",
      "mealSwap",
      "planCancel",
      "quickSale",
      "renewSubscription",
      "todaysMenu",
      "mealCard",
      "walletBalance",
      "walletHistory",
      "mealPlan",
      "daySelection",
      "summary",
      "hooks",
      "dietCenterTerms",
      "index",
      "dietPreference",
      "loadingTransition",
      "planPreferences",
      "allPlans",
      "featuredPlans",
      "categorySelection",
    ],
    detection: {
      order: ["customDetector", "localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
